import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-del",
  "use": "icon-del-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-del\"><path d=\"M445.4 771c18.8 0 34.1-15.2 34.1-34.1l-34.1-340.4c0-18.8-15.2-34.1-34.1-34.1s-34.1 15.2-34.1 34.1l34.1 340.4c0.1 18.8 15.3 34.1 34.1 34.1z m408.5-578.8H615.7v-17c0-37.6-30.5-68.1-68.1-68.1h-68.1c-37.6 0-68.1 30.5-68.1 68.1v17H173.1c-18.8 0-34.1 15.2-34.1 34.1 0 18.8 15.2 34.1 34.1 34.1H854c18.8 0 34.1-15.2 34.1-34.1s-15.3-34.1-34.2-34.1z m-306.3 0h-68.1v-17h68.1v17z m241.8 102.7c-19.8 0-36 15.6-36.9 35.2l-75.5 509H350.3l-75.8-510.6h-0.4c-1.8-18.8-17.6-33.6-36.7-33.6-19.3 0-35.1 14.7-36.7 33.6h-1.3l69.8 530.7c0.3-2.8 0.1-5.9-0.5-9.3 5.1 32.5 33.3 57.3 67.2 57.3h356.2c34.1 0 62.3-25 67.2-57.5-0.4 2.2-0.5 4.2-0.5 6.3L828 328.4h-1.8c-1.9-18.8-17.6-33.5-36.8-33.5z m-173.7 442l34.1-340.4c0-18.8-15.2-34.1-34.1-34.1s-34.1 15.2-34.1 34.1l-34.1 340.4c0 18.8 15.2 34.1 34.1 34.1 18.8 0 34.1-15.3 34.1-34.1z\" p-id=\"20454\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/del.svg
// module id = CWZL
// module chunks = 27